exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".budget-bar .percentage-container{position:relative;width:100%;height:4px;background-color:#fff;border-radius:4px;margin-bottom:10px}.budget-bar .percentage-container .percentage-width{position:absolute;left:0;height:4px;border-radius:4px;background-color:#46aaf6}.budget-bar .budget-text{font-size:14px;line-height:16px;color:#000}.budget-bar .budget-text>div,.budget-bar .budget-text>span{font-size:13px;line-height:15px;color:#666}.budget-bar.warning{margin-bottom:0}.budget-bar.warning .percentage-container .percentage-width{background-color:#f1533e}.budget-bar.warning .budget-text{color:#f1533e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Campaign/AppsBudgets/PercentageBar.vue
// module id = 106
// module chunks = 20